import React, { useState, useEffect } from "react";
import Header from "../../component/loaderComponent/Header/Header";
import Sidebar from "../Sidebar";
import './editroles.scss';
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { UpdateRoleAction, RoleNameListAction, PermissionAction, ReportNameAction } from "../../actions/RoleAction"
import { notify } from '../../services/notification';
import { HiMenu, HiX } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { decode } from "base-64";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useMobileView from "../../constants/useMobileView";


function EditRole() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();
    const { isSidebarOpen, toggleSidebar } = useMobileView();

    const [loading, setloading] = useState(false);

    const [permissions, setPermissions] = useState([]);
    const [supervisers, setSupervisers] = useState([]);
    const [states, setStates] = useState({
        role: "",
        reports_to_id: "",
        permission_ids: Array(),
        roleError: ""
    })

    async function GetRoleNameListData() {
        var response = await dispatch(RoleNameListAction("/" + decode(id)));
        if (response?.status === 200) {
            setStates({
                role: response?.data?.data[0]?.role,
                permission_ids: (response?.data?.data[0].permissions.length > 0 ? response?.data?.data[0].permissions.map((val) => val.id) : []),
                reports_to_id: response?.data?.data[0]?.reports_to?.id,
                roleError: ""
            });
        }
    }

    useEffect(() => {
        if (id) {
            GetRoleNameListData()
            GetRoleNameData()
            GetPermissionsData()
        }
    }, [id])



    async function GetPermissionsData() {
        setloading(true);
        var response = await dispatch(PermissionAction());
        if (response?.status === 200) {
            setloading(false);
            setPermissions(response?.data?.data);
        } else if (response === undefined) {
            setloading(false);
        }
    }

    async function GetRoleNameData() {
        setloading(true);
        var response = await dispatch(ReportNameAction(decode(id)));
        if (response?.status === 200) {
            setloading(false);
            setSupervisers(response?.data?.results?.data);
        } else if (response === undefined) {
            setloading(false);
        }
    }



    const handleInput = (e) => {
        let key = e.target.name;
        let value = e.target.value;
        let error = "";

        if (key === "role") {
            if (value.length < 3) {
                error = "Role name must be at least 3 characters long";
            } else if (value.length > 25) {
                error = "Role name can not exceed 25 characters";
            }
        }

        if (key === "permission_ids") {
            let checked = e.target.checked;
            if (checked || states[key].length === 0) {
                let arr = [...states.permission_ids]
                setStates({ ...states, [key]: [...arr, Number(value)], roleError: error })
            } else {
                let arr = [...states.permission_ids].filter((val) => val !== Number(value))
                setStates({ ...states, [key]: [...arr], roleError: error })
            }
        } else if (key === "reports_to_id") {
            setStates({ ...states, [key]: Number(value), roleError: error })
        } else {
            setStates({ ...states, [key]: value, roleError: error })
        }
    }

    const CancelRole = (evt) => {
        navigate('/rolemanagement')
    }

    const handleOnUpdateClick = async (e) => {
        e.preventDefault();
        setloading(true);
        if (states.roleError === "") {
            let response = await dispatch(UpdateRoleAction(states, decode(id)));
            if (response?.status === 200) {
                notify.success(response.data.message)
                setloading(false);
                navigate("/rolemanagement")
            } else if (response?.status === 400) {
                setloading(false);
            } else if (response === undefined) {
                setloading(false);
            }
        } else {
            notify.error(states.roleError);
            setloading(false);
        }
    }

    return (
        <div className="edit-role-container">
            <div className="edit-role-main">
                <Header title="Edit Role" />
                {loading ? <Loader /> :
                    <form onSubmit={handleOnUpdateClick}>
                        <div className="edit-role-input-checkbox">
                            <div className="edit-role-check-box">
                                <div className="edit-role">
                                    <label className="lable-edit-role">Role Name</label>
                                    <input className="edit-role-input-field" type="text" value={states.role} onChange={handleInput} name="role" />
                                </div>
                                <div className="edit-role">
                                    <label></label>
                                    <div className="error-message-edit-role">
                                        {states.roleError && (
                                            <span className="error-message-role">{states.roleError}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="edit-role">
                                    <label className="lable-edit-role">Permissions</label>
                                </div>
                                <div className="edit-role">
                                    <div className="edit-role-checkbox-container">
                                        {
                                            permissions.length > 0 && permissions.map((val) =>
                                                <div className="edit-role-checkbox">
                                                    <input className="creates-role-checkbox" type="checkbox" checked={states.permission_ids.length > 0 && states.permission_ids.some((i) => i === val.id) ? true : false} name="permission_ids" value={val.id} onChange={handleInput} />
                                                    <label className="creates-roles-label">{val?.permission}</label>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>

                                <div className="edit-role">
                                    <label className="lable-edit-role">Reports To</label>
                                </div>
                                <div className="edit-role">
                                    <div className="edit-role-checkbox-container">
                                        {
                                            supervisers.length > 0 && supervisers.map((val) =>
                                                <div className="edit-role-checkbox-reports">
                                                    <input className="creates-role-checkbox" type="radio" checked={states?.reports_to_id === val.id ? true : false} name="reports_to_id" value={val.id} onChange={handleInput} />
                                                    <label className="creates-roles-label">{val?.role}</label>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="edit-role-button">
                                    <button className="edit-role-cancel-button" onClick={CancelRole}
                                    >Cancel</button>
                                    <button className="edit-role-save-button" disabled={states.role.length < 3 || !states.role || states.permission_ids.length === 0 || !states.reports_to_id || states.roleError} type="submit">Update</button>
                                </div>
                            </div>
                        </div>
                    </form>
                }
            </div>
        </div>
    )
}
export default EditRole;